import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=f95f1398"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"
import style0 from "./CatalogList.vue?vue&type=style&index=0&id=f95f1398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports